import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { PDFDocument } from 'pdf-lib'
import { CoursesService } from 'src/app/services/courses.service';
import { FileHelper, RouteHelper } from 'src/app/helpers';
import { IRentwiseCertificateQueryParams } from './rentwise-certificate.viewmodel';
import { ActivatedRoute } from '@angular/router';
import { Agency, User } from 'src/app/models';
import { UserService } from 'src/app/services/user.service';

type CourseProgress = {
  rentwiseProgress?: number;
  rentwiseCompletionDate?: Date;
  rentwiseCompletionInPerson?: boolean;
}

@Component({
  selector: 'app-rentwise-certificate',
  templateUrl: './rentwise-certificate.component.html',
  styleUrls: ['./rentwise-certificate.component.css']
})
export class RentwiseCertificateComponent implements OnInit {
  pdfDoc!: PDFDocument;
  src?: string;
  loading = false;
  loaded = false;
  error?: string;

  agency!: Agency;
  agencyID?: string;

  user!: User & CourseProgress;
  userID?: string;

  routeParams: IRentwiseCertificateQueryParams = {};

  constructor(
    private auth: AuthService,
    private coursesService: CoursesService,
    private userService: UserService,
    private route: ActivatedRoute
  ) { }

  // When the page is loaded, pull the profile infomation
  async ngOnInit(): Promise<void> {
    this.initAgency();
    this.loadRouteParams();
    this.loadData();
  }

  private initAgency() {
    this.agencyID = this.auth.agencyInfo._id;
  }

  private async loadData() {
    try {
      this.loading = true;
      this.loaded = false;

      const query = {
        agencyid:    this.agencyID,
        userid:      this.userID,
        getprogress: true,
      };

      const res: any = await this.userService.getRentwise(query).toPromise();

      this.agency = res.agency;
      this.user = res.users[0];

      const completionDate = this.user?.rentwiseCompletionDate;

      if (!this.agency || !this.user || !completionDate) {
        this.error = 'User certificate not found.';
        return;
      }

      // TODO: save certificates on S3 bucket
      this.pdfDoc = await this.coursesService.generateRentwiseCertificate(this.agency, this.user, completionDate) as any;

      // Serialize the PDFDocument to data URI for the pdf-viewer
      const pdfDataUri = await this.pdfDoc.saveAsBase64({ dataUri: true });

      this.src = pdfDataUri;
      this.loaded = true;
    }
    finally {
      this.loading = false;
    }
  }

  private loadRouteParams(): void {
    const queryParams = this.route.snapshot.queryParams as IRentwiseCertificateQueryParams;

    this.routeParams = RouteHelper.map(queryParams, {
      agencyid: String,
      userid: String,
    });

    this.agencyID = this.routeParams.agencyid || this.agencyID;
    this.userID = this.routeParams.userid;
  }

  async downloadPdf() {
    if (!this.pdfDoc) {
      return;
    }

    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfDoc.save();
    FileHelper.saveByteArray('certificate.pdf', pdfBytes, 'application/pdf');
  }
}
